import { render, staticRenderFns } from "./ActivitiesCard.vue?vue&type=template&id=b52ae744&"
import script from "./ActivitiesCard.vue?vue&type=script&lang=js&"
export * from "./ActivitiesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports